// 获取页面配置的Api
export const PAGE_CONFIG_API = '/api/v2/dashboard/studio/get_page_config';

// 特殊游戏做映射配置
export type ID3D4ConfigType = {
  [key: string]: { nameEn: string; nameCn: string; gameCode: string; };
};
export const SPECIAL_GAME_CONFIG: ID3D4ConfigType = {
  edc9481bd94ceffbbc75ac502fa287234: {
    nameEn: 'Diablo III Demo',
    nameCn: 'Diablo III Demo',
    gameCode: 'pc_demo'
  },
  e105fe4609b81f5b00fe298ddd2abce47: {
    nameEn: 'Diablo IV Demo',
    nameCn: 'Diablo IV Demo',
    gameCode: 'pc_demo'
  },
};

// 特殊游戏做映射配置
export const DASHBOARD_SENSITIVE_GAME = [
  // 消逝的光芒2
  'c00002645',
  // 消逝的光芒
  'c00002644',
  // Dying Light: The Beast
  'caba0f9bd807a6955c8a47c7c017ee925',
  // Dune: Awakening
  'c00002595',
  // Conan Exiles
  'c00001702',
  // Warframe - All
  'c00010343',
  'u8f17b82647b7d5a6fd87af8a807d2b08',
  'uc6fd4be3c4281c9f24b464359ddf60d8',
  // Path of Exile 2
  'c00006526',
  // EXOBORNE
  'c00038680',
  // 暗潮 Darktide
  'c00010348',
  // Warhammer: Vermintide 2
  'c00010367',
  // GTFO
  'c00003806',
  // Arma Reforger
  'c00000555',
  // DayZ
  'c00002035',
  // Arma 3
  'c00000554',
  // Silica
  'c00075701',
  // Everwind
  'c4f70018530a3dc54c5d99e722a23bd2f',
  // 8 Ball Pool
  'u0ea54cd6abaed768bad32cc70b4f6695',
  'c76f92c35d8e79d3f180bb79427baeeff',
  'uaa163d7c8e12046ef56b69d337fb18cd',
];

export const SEARCH_HISTORY_TYPE = {
  Game: 'game',
  AIAgent: 'ai_agent',
  AINavigation: 'ai_navigation',
} as const;
